module.exports = __webpack_public_path__ + "256e71e1567e94b6b74eee8cbe9ed763.jpg";